export enum HOURS_SYSTEMS {
  h12 = "12",
  h24 = "24",
}
